import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function UpdateLicense({ open, onClose, setOpen }: ModalProps) {
  return (
    <Modal className="modal addReply_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Update Document</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form wrap_viewDemo_steps" action="">
            <div className="control_group">
              <label htmlFor="">Select Document</label>
              <FormControl fullWidth>
                <Select defaultValue="Technical Issue">
                  <MenuItem value="Technical Issue">Trade License</MenuItem>
                  <MenuItem value="Billing Issue">MOA</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="control_group w_50">
              <label htmlFor="icon-button-file">Upload Document</label>
             <div className="upload_box">
                <label className='upload_action'>
                  <p>
                    <img src="/static/images/upload_icon.svg" alt='icon' />
                    <strong>Click to upload </strong>
                  </p>
                </label>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
             Verify with AI
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
